import { Avatar, Card, CardActionArea, Stack, Typography } from '@mui/material'
import { Divider, EmphasizedNumber, Icons } from 'utoniq-ui'

import {
  MagazineItemFragment,
  UserPaymentType,
} from '@/clients/utoniq-core/schema'
import { styleSets } from '@/components/styles'
import { config } from '@/config'
import { useRouter, useTranslation } from '@/core'
import { Organism } from '@/core/architecture'
import { useAnalytics } from '@/lib/analytics'

type MagazineItemProps = {
  item: MagazineItemFragment
  divider: boolean
  /** analyticsクリックイベント時の導線名 */
  conductorName: string
}
export const MagazineItem: Organism<MagazineItemProps> = ({
  item,
  divider,
  conductorName,
}) => {
  const { t } = useTranslation('newStoreItems')
  const { generatePath, routerPages } = useRouter()
  const { analytics } = useAnalytics()

  return (
    <Card elevation={0} sx={{ bgcolor: 'transparent', borderRadius: 0 }}>
      <CardActionArea
        href={generatePath(routerPages.ArtistStoreItemDetail, {
          itemId: item.id,
          artistId: item.issuedArtist?.id,
        })}
        onClick={() => {
          analytics?.track('click_select', {
            applicationKey: config.applicationKey,
            artistId: item.issuedArtist?.id,
            itemId: item.id,
            name: conductorName,
          })
        }}
      >
        <Stack direction="row" spacing={4}>
          <Avatar
            variant="square"
            src={item.thumbnail.front?.mediumUri ?? ''}
            sx={{ height: 96, width: 60 }}
          />
          <Stack spacing={1} py={2} sx={{ minWidth: 0 }}>
            {!!item.collection?.title && (
              <Typography variant="overline" color="text.secondary">
                {item.collection.title}
              </Typography>
            )}
            <Typography variant="subtitle1" sx={styleSets.lineCamp(1)}>
              {item.title}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={styleSets.lineCamp(1)}
            >
              {item.description}
            </Typography>
            {item.price ? (
              <Stack direction="row" alignItems="center" spacing={1}>
                {item.paymentType === UserPaymentType.Cash ? (
                  <EmphasizedNumber color="inherit" variant="subtitle1">
                    {'¥ '}
                  </EmphasizedNumber>
                ) : (
                  <Icons.Point fontSize="small" />
                )}
                <EmphasizedNumber color="inherit" variant="subtitle1">
                  {item.price}
                </EmphasizedNumber>
              </Stack>
            ) : (
              <Typography variant="overline" color="primary">
                {t('free', '無料')}
              </Typography>
            )}
          </Stack>
        </Stack>
      </CardActionArea>
      {divider && <Divider sx={{ mt: 2 }} />}
    </Card>
  )
}
